import gql from 'graphql-tag'

export const SYNC_CHANNEX_STRUCTURE_MUTATION = gql`
  mutation SyncChannexStructure {
    syncChannexStructure {
      createdRoomTypes
      matchedRoomTypes
      createdRatePlans
      matchedRatePlans
      skipped
    }
  }
`
